import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import { MenuInfo } from './menu'
import MenuItem from './MenuItem.vue'
import * as accountTypes from '@account/store/types'

interface web2appPayload {
    group: string
    function: string
    args: any
}

@Component({ 
    name: 'menuList',
    components: { MenuItem },
    methods: {
        ...mapActions({
            logout: accountTypes.LOGOUT
        })
    },
    computed: {
        ...mapGetters({
            user: accountTypes.USER
        })
    }
})
export default class MenuList extends Vue {
    @Prop({ type: Array, default: [] }) items!: MenuInfo[]

    logout!: () => Promise<void>

    user!: account.User
    userId: string = ''

    handleLogout() {
        this.logout().then(async res => {
            var payload: web2appPayload = {
                group: 'login',
                function: 'logout',
                args: {
                    userId: this.userId
                }
            };

            if(this.userId == 'ISU_ST99999') {
                await(window as any).alertAsync(payload.args.userId)
            }

            (window as any).dsmobileapp.web2app(payload.group, payload.function, payload.args);
        })
    }

    created() {
        this.userId = this.user.id
    }
}